module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-ppt-fill-ef5cef53.svg";